import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { searchAsmtTemp } from '../../../services/apps/AssessmentTempServices';
import { renderAsyncSelector } from '../../../components/formik-components/FormAsyncSelector';
import Debug from '../../../components/Debug';
import { LegacyInputTextComponent, TextAreaWithValidation } from '../../../components/prime-formik';
import { withAccount } from '../../../components/AccountContext';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import { growlErrors } from '../../../utils/NotificationUtil';

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  asmtTemp: Yup.object().required('Required'),
});

class NewJobForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      asmtTemps: [],
      tempLoading: false,
    };
    this.searchAsmt = this.searchAsmt.bind(this);
    this.cancelCreatingNewJob = this.cancelCreatingNewJob.bind(this);
  }

  componentDidMount() {
    this.fetchAsmtTemp();
  }

  searchAsmt(query) {
    this.fetchAsmtTemp(query);
  }

  async fetchAsmtTemp(query) {
    const { growl, match } = this.props;
    const { aid } = match.params;
    this.setState({
      tempLoading: true,
    });
    try {
      const data = await searchAsmtTemp({
        aid,
        query,
      });
      this.setState({
        asmtTemps: data,
        tempLoading: false,
      });
    } catch (err) {
      growlErrors(growl, err);
      this.setState({
        tempLoading: false,
      });
    }
  }

  cancelCreatingNewJob() {
    const { history, currentAccount } = this.props;
    const redirectUrl = `/accounts/${currentAccount}/job-profiles/`;
    history.push(redirectUrl);
  }

  saveJob(values) {
    const { saveJobProfile } = this.props;
    const input = {
      name: values.name,
      internalDescription: values.internalDescription,
      assessmentTemplateId: values.asmtTemp.id,
    };
    saveJobProfile(input);
  }

  render() {
    const { isSaving } = this.props;
    const { asmtTemps, tempLoading } = this.state;
    return (
      <Formik
        initialValues={{ name: '' }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          this.saveJob(values);
        }}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-6">
                <FormattedMessage id="attrs.name" defaultMessage="Name">
                  {text => (
                    <label className="field-label" htmlFor="job-name">
                      {text}
                    </label>
                  )}
                </FormattedMessage>
                <FormattedMessage id="attrs.name" defaultMessage="Name">
                  {text => <Field id="name" name="name" component={LegacyInputTextComponent} placeholder={text} />}
                </FormattedMessage>
              </div>
            </div>
            <div className="p-grid">
              <div className="p-col-12 p-md-6">
                <FormattedMessage id="attrs.assessmentTemplate" defaultMessage="Assessment Template">
                  {text => (
                    <label className="field-label" htmlFor="job-assessment">
                      {text}
                    </label>
                  )}
                </FormattedMessage>
                <FormattedMessage id="choose" defaultMessage="Choose">
                  {text => (
                    <Field
                      component={renderAsyncSelector}
                      data={asmtTemps}
                      processing={tempLoading}
                      textField="title"
                      valueField="id"
                      filter
                      setFieldValue={props.setFieldValue}
                      name="asmtTemp"
                      placeholder={`-- ${text} --`}
                      onSearch={this.searchAsmt}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-6">
                <FormattedMessage id="attrs.internalDescription" defaultMessage="Internal description">
                  {text => (
                    <label className="field-label" htmlFor="job-internal-desc">
                      {text}
                    </label>
                  )}
                </FormattedMessage>
                <Field
                  className="form-control"
                  component={TextAreaWithValidation}
                  cols={40}
                  id="job-internal-desc"
                  name="internalDescription"
                />
              </div>
            </div>
            <div className="p-grid">
              <div className="p-col-12">
                <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
                  {text => (
                    <Button
                      type="button"
                      onClick={this.cancelCreatingNewJob}
                      className="p-button-secondary"
                      disabled={!!isSaving}
                      label={text}
                    />
                  )}
                </FormattedMessage>
                <FormattedMessage id="actions.save" defaultMessage="Save">
                  {text => (
                    <Button
                      type="submit"
                      data-t="save"
                      icon={isSaving ? 'pi pi-spin pi-spinner' : ''}
                      label={text}
                      disabled={!!isSaving}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
            <Debug />
          </form>
        )}
      />
    );
  }
}

NewJobForm.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  saveJobProfile: PropTypes.func.isRequired,
  growl: growlShape.isRequired,
  isSaving: PropTypes.bool.isRequired,
};

export default withGrowl(withRouter(withAccount(NewJobForm)));
